var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEcosystem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M37.1387 22.6582C41.0604 22.1174 44.4639 23.1171 45.4268 23.2891V23.2881C51.2669 24.3478 56.3154 30.6806 57.3203 37.9424C57.8196 41.551 57.3096 45.351 55.417 48.7871C53.5852 52.1125 50.4412 55.1292 45.5938 57.3057L45.1191 57.5127C39.61 59.8674 32.5158 57.8235 27.7012 53.3027L27.2422 52.8574C24.1774 49.7883 23.3257 45.5151 23.5283 41.3965C23.7182 37.5371 24.8316 33.8862 25.8271 31.6592L26.0244 31.2334V31.2324C28.8837 25.2411 33.2586 23.1933 37.1387 22.6582Z",
    stroke: "#A3B1C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M34.9844 10.7637C41.4321 9.86367 47.0422 11.5259 48.5771 11.8037V11.8047C58.2608 13.5827 66.5546 24.1708 68.2041 36.2383C69.0257 42.2489 68.1874 48.5859 65.0674 54.3203C62.0467 59.8721 56.8705 64.89 48.9219 68.5029L48.1436 68.8477C38.8806 72.8554 26.9696 69.2471 19.0615 61.4775L18.6885 61.1045H18.6875C13.6071 55.9541 12.2136 48.8007 12.5459 41.9619C12.8574 35.5529 14.6834 29.4936 16.3193 25.7891L16.6436 25.0801V25.0791C21.3531 15.0894 28.5778 11.658 34.9844 10.7637Z",
    stroke: "#A3B1C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0947 33.5615C40.721 33.3494 42.1211 33.7392 42.5645 33.8145V33.8154C44.9215 34.2198 47.0098 36.6639 47.4258 39.5078C47.6308 40.9097 47.4212 42.3788 46.6484 43.7061C45.9248 44.9486 44.6892 46.0985 42.7695 46.9531L42.376 47.1201C40.1355 48.0257 37.2035 47.2439 35.2012 45.4658L35.0107 45.29H35.0098C33.7831 44.128 33.4276 42.4988 33.5117 40.8799C33.5854 39.4625 33.9957 38.1128 34.3848 37.2305L34.5488 36.8818L34.5498 36.8809C35.7223 34.5569 37.5026 33.7692 39.0947 33.5615Z",
    stroke: "#8797AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2415 46.0027C26.5277 43.8913 24.1315 42.4778 21.4869 42.0182C12.8902 41.5305 6.33766 50.9213 8.37372 58.3364C8.811 60.1329 9.66848 61.7938 10.8723 63.176C12.0762 64.5583 13.5903 65.6205 15.2844 66.2712C16.9785 66.9218 18.8017 67.1415 20.5972 66.9113C22.3927 66.6811 24.1066 66.0079 25.5914 64.9496C28.5566 62.9657 31.1016 59.9897 31.8126 56.3938C32.6044 52.3762 30.7865 48.9291 28.2415 46.0027Z",
    fill: "#EDF2F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9101 19.4638C51.3443 14.6092 44.7619 13.645 40.6365 16.9118C36.0666 19.3142 33.3079 24.5511 36.1588 29.3808C38.9343 34.1023 45.3154 35.2744 49.9523 32.5728C52.1858 31.3115 53.8433 29.2456 54.5803 26.8043C55.3173 24.3631 55.0773 21.7342 53.9101 19.4638Z",
    fill: "#EDF2F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47000_23408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 29V20C43 19.7348 43.1054 19.4804 43.2929 19.2929C43.4804 19.1054 43.7348 19 44 19H48C48.2652 19 48.5196 19.1054 48.7071 19.2929C48.8946 19.4804 49 19.7348 49 20V29M43 29H49M43 29H42C41.7348 29 41.4804 28.8946 41.2929 28.7071C41.1054 28.5196 41 28.2652 41 28V25C41 24.7348 41.1054 24.4804 41.2929 24.2929C41.4804 24.1054 41.7348 24 42 24H43M49 29H50C50.2652 29 50.5196 28.8946 50.7071 28.7071C50.8946 28.5196 51 28.2652 51 28V23.5C51 23.2348 50.8946 22.9804 50.7071 22.7929C50.5196 22.6054 50.2652 22.5 50 22.5H49M45 21H47M45 23H47M45 25H47M45 27H47",
    stroke: "#6D33FF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 29V20C43 19.7348 43.1054 19.4804 43.2929 19.2929C43.4804 19.1054 43.7348 19 44 19H48C48.2652 19 48.5196 19.1054 48.7071 19.2929C48.8946 19.4804 49 19.7348 49 20V29M43 29H49M43 29H42C41.7348 29 41.4804 28.8946 41.2929 28.7071C41.1054 28.5196 41 28.2652 41 28V25C41 24.7348 41.1054 24.4804 41.2929 24.2929C41.4804 24.1054 41.7348 24 42 24H43M49 29H50C50.2652 29 50.5196 28.8946 50.7071 28.7071C50.8946 28.5196 51 28.2652 51 28V23.5C51 23.2348 50.8946 22.9804 50.7071 22.7929C50.5196 22.6054 50.2652 22.5 50 22.5H49M45 21H47M45 23H47M45 25H47M45 27H47",
    stroke: "url(#paint0_linear_47000_23408)",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6433 52.3451C69.0465 50.3751 67.7461 48.6671 65.9681 47.5179C64.1901 46.3687 62.0468 45.851 59.9107 46.0547C54.7313 45.4645 49.9496 49.7335 50.0004 54.8192C50.0492 56.1102 50.3724 57.3783 50.9503 58.5462C51.5283 59.7141 52.3488 60.7575 53.3622 61.6129C54.3755 62.4683 55.5604 63.1179 56.8448 63.522C58.1291 63.9261 59.4861 64.0764 60.8332 63.9637C66.7743 63.333 71.3359 58.1423 69.6433 52.3451Z",
    fill: "#EDF2F7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_47000_23408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 60.6666V48.6666C15.9997 48.313 16.1402 47.9738 16.3902 47.7238C16.6402 47.4737 16.9794 47.3333 17.333 47.3333H22.6663C23.02 47.3333 23.3591 47.4737 23.6092 47.7238C23.8592 47.9738 23.9997 48.313 23.9997 48.6666V60.6666M15.9997 60.6666H23.9997M15.9997 60.6666H14.6663C14.3127 60.6666 13.9736 60.5261 13.7235 60.2761C13.4735 60.026 13.333 59.6869 13.333 59.3333V55.3333C13.333 54.9796 13.4735 54.6405 13.7235 54.3904C13.9736 54.1404 14.3127 53.9999 14.6663 53.9999H15.9997M23.9997 60.6666H25.333C25.6866 60.6666 26.0258 60.5261 26.2758 60.2761C26.5259 60.026 26.6663 59.6869 26.6663 59.3333V53.3333C26.6663 52.9796 26.5259 52.6405 26.2758 52.3904C26.0258 52.1404 25.6866 51.9999 25.333 51.9999H23.9997M18.6663 49.9999H21.333M18.6663 52.6666H21.333M18.6663 55.3333H21.333M18.6663 57.9999H21.333",
    stroke: "#6D33FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 60.6666V48.6666C15.9997 48.313 16.1402 47.9738 16.3902 47.7238C16.6402 47.4737 16.9794 47.3333 17.333 47.3333H22.6663C23.02 47.3333 23.3591 47.4737 23.6092 47.7238C23.8592 47.9738 23.9997 48.313 23.9997 48.6666V60.6666M15.9997 60.6666H23.9997M15.9997 60.6666H14.6663C14.3127 60.6666 13.9736 60.5261 13.7235 60.2761C13.4735 60.026 13.333 59.6869 13.333 59.3333V55.3333C13.333 54.9796 13.4735 54.6405 13.7235 54.3904C13.9736 54.1404 14.3127 53.9999 14.6663 53.9999H15.9997M23.9997 60.6666H25.333C25.6866 60.6666 26.0258 60.5261 26.2758 60.2761C26.5259 60.026 26.6663 59.6869 26.6663 59.3333V53.3333C26.6663 52.9796 26.5259 52.6405 26.2758 52.3904C26.0258 52.1404 25.6866 51.9999 25.333 51.9999H23.9997M18.6663 49.9999H21.333M18.6663 52.6666H21.333M18.6663 55.3333H21.333M18.6663 57.9999H21.333",
    stroke: "url(#paint1_linear_47000_23408)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_47000_23408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 59V50C57 49.7348 57.1054 49.4804 57.2929 49.2929C57.4804 49.1054 57.7348 49 58 49H62C62.2652 49 62.5196 49.1054 62.7071 49.2929C62.8946 49.4804 63 49.7348 63 50V59M57 59H63M57 59H56C55.7348 59 55.4804 58.8946 55.2929 58.7071C55.1054 58.5196 55 58.2652 55 58V55C55 54.7348 55.1054 54.4804 55.2929 54.2929C55.4804 54.1054 55.7348 54 56 54H57M63 59H64C64.2652 59 64.5196 58.8946 64.7071 58.7071C64.8946 58.5196 65 58.2652 65 58V53.5C65 53.2348 64.8946 52.9804 64.7071 52.7929C64.5196 52.6054 64.2652 52.5 64 52.5H63M59 51H61M59 53H61M59 55H61M59 57H61",
    stroke: "#6D33FF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 59V50C57 49.7348 57.1054 49.4804 57.2929 49.2929C57.4804 49.1054 57.7348 49 58 49H62C62.2652 49 62.5196 49.1054 62.7071 49.2929C62.8946 49.4804 63 49.7348 63 50V59M57 59H63M57 59H56C55.7348 59 55.4804 58.8946 55.2929 58.7071C55.1054 58.5196 55 58.2652 55 58V55C55 54.7348 55.1054 54.4804 55.2929 54.2929C55.4804 54.1054 55.7348 54 56 54H57M63 59H64C64.2652 59 64.5196 58.8946 64.7071 58.7071C64.8946 58.5196 65 58.2652 65 58V53.5C65 53.2348 64.8946 52.9804 64.7071 52.7929C64.5196 52.6054 64.2652 52.5 64 52.5H63M59 51H61M59 53H61M59 55H61M59 57H61",
    stroke: "url(#paint2_linear_47000_23408)",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47000_23408",
    x1: 40.3372,
    y1: 21.0353,
    x2: 51.4078,
    y2: 26.9475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47000_23408",
    x1: 12.4492,
    y1: 50.047,
    x2: 27.2101,
    y2: 57.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47000_23408",
    x1: 54.3372,
    y1: 51.0353,
    x2: 65.4078,
    y2: 56.9475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47000_23408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(40 18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_47000_23408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 46)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_47000_23408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(54 48)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEcosystem);
export default __webpack_public_path__ + "static/media/icon-ecosystem.c42ce25a07144996b12b58d227c22d76.svg";
export { ForwardRef as ReactComponent };